import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Footer = () => {
  const quickLinks = [
    { name: 'Home', to: '/' },
    { name: 'About', to: '/about' },
    { name: 'Services', to: '/services' },
    { name: 'Products', to: '/products' },
    { name: 'Blog', to: '/blog' },
    { name: 'Contact', to: '/contact' },
  ];

  const contactInfo = [
    { icon: 'ri-mail-line', text: 'info@quarkpower.ca', href: 'mailto:info@quarkpower.ca' },
    { icon: 'ri-map-pin-line', text: 'Canada' }
  ];

  return (
    <footer className="bg-gradient-to-br from-emerald-600 via-emerald-700 to-green-700 text-white relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-16 relative z-10">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Company Info */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h3 className="text-2xl font-bold mb-4">Quark Power Inc.</h3>
            <p className="text-white/80 text-sm leading-relaxed mb-6">
              Advancing the next generation of EMT simulation platforms for modern power systems.
            </p>
            <div className="flex gap-3">
              <a href="https://www.linkedin.com/company/quark-power-inc" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-all cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <h3 className="text-xl font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.to}
                    className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer whitespace-nowrap inline-flex items-center group"
                  >
                    <i className="ri-arrow-right-s-line mr-1 group-hover:translate-x-1 transition-transform"></i>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h3 className="text-xl font-bold mb-6">Contact Us</h3>
            <ul className="space-y-4">
              {contactInfo.map((info, index) => (
                <li key={index} className="flex items-start">
                  <i className={`${info.icon} text-xl mr-3 mt-0.5`}></i>
                  {info.href ? (
                    <a href={info.href} className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                      {info.text}
                    </a>
                  ) : (
                    <span className="text-white/80 text-sm">{info.text}</span>
                  )}
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>

      <div className="border-t border-white/20 relative z-10">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <p className="text-center text-sm text-white/70">
            Copyright © 2026 Quark Power Inc. All Rights Reserved. | <Link to="/privacy" className="hover:text-white transition-colors whitespace-nowrap">Privacy Policy</Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
